// extracted by mini-css-extract-plugin
module.exports = {"grid_item":"_1awYw","slider":"_3pv0I","slide":"_3pT0S","slideImage":"_3SnRN"};